<template>
  <LeftSide :is-loading="isLoading">
    <template v-slot:title>
      Evaluation
    </template>

    <tabs v-if="tabs.length > 1"
          v-model="currentTab"
          :tabItems="tabs"
          :defaultTab="activeTabComponent">
      <template slot="tab-content">
        <EditReview v-if="showEditReview"
                    :is-loading="isLoading"
                    :review="review"
                    :reviews="reviews"/>
        <EditReport v-if="activeTabComponent === 'nomination_report'"
                    @reportSubmitted="handleReportSubmitted"
                    type="nomination"
                    :reportable="nomination"/>
        <EditReport v-if="activeTabComponent === 'award_report'"
                    @reportSubmitted="handleReportSubmitted"
                    type="award"
                    :reportable="nomination.award"/>
      </template>
    </tabs>
    <div v-else>
      <EditReview v-if="!isLoading"
                  :is-loading="isLoading"
                  :review="review"
                  :reviews="reviews"/>
    </div>
  </LeftSide>
</template>

<script>
import LeftSide from '@/views/areas/awards/LeftSide.vue';
import reviewsMixin from '@/mixins/awards/reviews.mixin';
import EditReview from '@/views/areas/awards/reviews/partials/EditReview.vue';
import EditReport from '@/views/areas/awards/reviews/partials/EditReport.vue';
import Tabs from '@/views/components/Tabs.vue';

export default {
  name: 'ReviewsEdit',
  mixins: [reviewsMixin],
  components: {
    Tabs,
    LeftSide,
    EditReview,
    EditReport,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    review: {
      type: Object,
      required: true,
    },
    reviews: Array,
  },
  data() {
    return {
      currentTab: '',
    };
  },
  methods: {
      handleReportSubmitted() {
        this.$router.push({ name: 'Reviews' });
      },
  },
  computed: {
    nomination() {
      return this.review.nomination;
    },
    activeTabComponent() {
      return this.$route.query.section ?? this.tabs[0]?.name;
    },
    tabs() {
      const tabs = [];

      if (this.review.can.update || this.review.can.viewAllReviews) {
        tabs.push({ name: 'nomination_reviews', label: 'Nomination Reviews' });
      }

      if (this.nomination?.can.viewReports) {
        tabs.push({ name: 'nomination_report', label: 'Nomination Report' });
        tabs.push({ name: 'award_report', label: 'Award Report' });
      }

      return tabs;
    },
    showEditReview() {
      return this.activeTabComponent === 'nomination_reviews'
        && this.review.can.view
        && this.review.can.viewAllReviews;
    },
  },
};
</script>
